import React, { Component } from 'react'
import { Table, TableHeader, TableRow } from 'features/Table'
import Button from 'components/Button'
import IconVoice from 'components/Icons/Voice'
import IconMessage from 'components/Icons/Message'
import IconFax from 'components/Icons/Fax'
import sMarg from 'styles/modules/margins.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import s from './NumbersAvailableTable.scss'
import { Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import LoadingLinear from 'components/Loading/LoadingLinear'

export default class NumbersAvailableTable extends Component {
  componentWillMount() {
    const { getAvailableNumbers, country, type, filter, cacheKey } = this.props
    getAvailableNumbers({ country, type, filter, cacheKey })
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.cacheKey !== this.props.cacheKey) {
      const { getAvailableNumbers, country, type, filter, cacheKey } = nextProps
      if (!(filter && filter.contains && filter.contains.length === 1)) {
        getAvailableNumbers({ country, type, filter, cacheKey })
      }
    }
  }
  render() {
    const { availableNumbers, onSelect, value, type } = this.props

    const results = availableNumbers.data || []

    const tableHeader = (
      <TableHeader>
        <div>Number</div>
        <div className={sLay['hide-xs']}>Capabilities</div>
        {type === 'local' && <div>Location</div>}
        <div style={{ maxWidth: '82px' }} />
      </TableHeader>
    )

    return (
      <div>
        <div className={sMarg.mb30}>
          <Field
            label="Search Numbers"
            component={Input}
            type="number"
            name="filter.contains"
            info="Enter at least 2 numbers to start search"
          />
        </div>
        <Table header={tableHeader} className={s.table}>
          {results.map(service => (
            <TableRow key={service.friendlyName}>
              <div>{service.friendlyName}</div>
              <div className={cn(s.capabilities, sLay['hide-xs'])}>
                {service.capabilities.voice && (
                  <span title="Voice">
                    <IconVoice size={20} />
                  </span>
                )}
                {service.capabilities.SMS && (
                  <span title="SMS">
                    <IconMessage size={20} />
                  </span>
                )}
                {service.capabilities.fax && (
                  <span title="Fax">
                    <IconFax size={20} />
                  </span>
                )}
              </div>
              {type === 'local' && (
                <div>
                  {service.locality} {service.postalCode}
                </div>
              )}
              <div style={{ maxWidth: '82px' }}>
                <Button
                  onClick={() => onSelect(service)}
                  color="tertiary"
                  size="xs"
                  ghost={value !== service.phoneNumber}
                >
                  Select
                </Button>
              </div>
            </TableRow>
          ))}
          {results.length === 0 && !availableNumbers.loading && <TableRow>No results</TableRow>}
          {availableNumbers && availableNumbers.loading && (
            <div>
              <br />
              <br />
              <LoadingLinear />
            </div>
          )}
        </Table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersAvailableTable/NumbersAvailableTable.jsx